import React, { Component } from "react";
import { connect } from "react-redux";
import IconPlus from "../../../../assets/Files-icon.svg";
import Files from "react-files";
import {
  ERROR_MSG,
  STATUS,
  IMAGE_FORMAT,
  FILE_SIZE_LIMIT
} from "../../../../constant";
import { DatePicker } from "../../../../component";
import {
  DATE_VALIDATE,
  DESCRIPTION_VALIDATE,
  TITLE_VALIDATE,
  IMAGE_VALIDATE
} from "../../../../validation";
import { debounce, get } from "lodash";
import { bindActionCreators } from "redux";
import {
  uploadFileAction,
  removeFileAction
} from "../../../../actions/common.action";
import {
  pmgMemberUpdateFormAction,
  pmgUpdateAddMemberFormAction
} from "../../../../actions/pmgTeam.action";
import {
  isValidArray,
  setLocalstorage,
  searchByValueHelper,
  FormDataForImage
} from "../../../../helper";
import { Form, Spinner, InputGroup, Button, Image } from "react-bootstrap";
import { ConfirmationComponent } from "../../../ConfirmationComponent";
import { JSEncrypt } from "jsencrypt/lib";
import { faAddressCard } from "@fortawesome/free-solid-svg-icons";
import { Cursor } from "react-bootstrap-icons";
import { successToastStyle, errorToastStyle } from "../../../../customToast";
import { toast } from "react-toastify";
import CancleIcon from "../../../../assets/Group 7628.svg";
import ImageBackground from "../../../../assets/ImageBackground.svg";
import { LoaderPage } from "../../../../component/Loader";
import { red } from "@material-ui/core/colors";

export class CreateForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      pageURL: "",
      description: "",
      date: "",
      file: "",
      releaseDate: "",
      editData: "",
      submitBtnText: "UPDATE",
      selectedDate: null,
      errors: {},
      active: false,
      isActive: (this.props.groupData && this.props.groupData.active) || false,
      isToggleOn: true,
      isProfiled: false,
      selectedImage: null,
      imageURL: null,
      image: null,
      files: [],
      count: 0,
      extension: null,
      isLoading: false,
      newActive: true,
      dataUnsaved: false,
      allowPrompt: true
    };
    this.handleDateChange = this.handleDateChange.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    this.getImageType();
    //console.log(this.state.extension, "extension");
    //console.log(this.props, "props");
    let formattedDate;
    if (this.props.isEdit) {
      const date11 = new Date(this.props.groupData.releaseDate);
      const day = date11.getDate();
      //console.log("day", day);
      const month = date11.getMonth() + 1; // Months are 0-indexed, so add 1
      //console.log("month", month);
      const year = date11.getFullYear();
      //console.log("year", year);
      formattedDate = `${day}-${month}-${year}`;
      //console.log("formattedDate", formattedDate);
    }

    this.setState({
      title: this.props.isEdit ? this.props.groupData.title : "",
      pageURL: this.props.isEdit ? this.props.groupData.pageUrl : "",
      description: this.props.isEdit ? this.props.groupData.description : "",
      editDate: this.props.isEdit ? formattedDate : "",
      count: this.props.isEdit ? this.props.groupData.image[0].id : "",
      selectedImage: this.props.isEdit
        ? this.props.groupData.image[0].mineType
        : ""
    });
  }

  componentWillUnmount() {
    // Clean up the event listener
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = event => {
    const { togglePopUp } = this.props;
    const { dataUnsaved, allowPrompt } = this.state;

    // Check if the click was outside the modal
    const modalRef =
      this.props.updateModalRef && this.props.updateModalRef.current;
    const isOutsideModal = modalRef && !modalRef.contains(event.target);

    // Check if the click was on the vertical scrollbar
    const isClickOnScrollbar =
      event.clientX > window.innerWidth - 7 &&
      (event.clientY >= 0 && event.clientY <= window.innerHeight);

    // If the click is outside the modal and not on the scrollbar
    if (isOutsideModal && !isClickOnScrollbar) {
      console.log(
        "Clicked outside the modal, but modal will not close.",
        dataUnsaved
      );
      if (dataUnsaved && allowPrompt && event.button === 0) {
        event.preventDefault();
        const confirmLeave = window.confirm(
          "You have unsaved changes, are you sure you want to leave?"
        );

        if (confirmLeave) {
          togglePopUp(event);
          return;
        }
      }
    }
  };

  handleDateChange(date) {
    this.setState({
      selectedDate: date,
      dataUnsaved: true
    });
    //console.log(date, "date");
  }

  handleEditDateChange(date) {
    this.props.groupData.releaseDate = date;
    //console.log(this.props.groupData.releaseDate)
    this.setState({
      selectedDate: date,
      dataUnsaved: true
    });
  }

  onChange = (value, key) => {
    const { getGroupRolesForUser } = this.props;
    if (key === "groupId") {
      this.setState(
        {
          rolesList: [],
          dataUnsaved: true
        },
        async () => {
          const response = await getGroupRolesForUser(undefined, value);
          if (response) {
            const { data, status, message } = response;
            status
              ? toast.success(
                  <p className="toast-text-alignment">{message}</p>,
                  successToastStyle
                )
              : toast.error(
                  <p className="toast-text-alignment">{message}</p>,
                  errorToastStyle
                );
            if (isValidArray(data.data)) {
              this.setState({
                rolesList: data.data
              });
              this.getFilteredData({ sortData: data.data });
            } else {
              this.setState({
                rolesList: []
              });
            }
          }
        }
      );
    } else {
      this.setState(async prevState => {
        prevState[key] = prevState[key] || [];
        const indexId = prevState[key].indexOf(+value);
        indexId !== -1
          ? prevState[key].splice(indexId, 1)
          : prevState[key].push(+value);
        prevState[key] = [...prevState[key]];
        return {
          [key]: prevState[key],
          dataUnsaved: true
        };
      });
    }
  };

  toggleActive = () => {
    this.setState(prevState => ({
      isActive: !prevState.isActive
    }));
  };

  handleRadioChange = () => {
    this.setState(prevState => ({
      isActive: !prevState.isActive
    }));
  };

  handleChange = e => {
    e.preventDefault();
    e.stopPropagation();
    const { name, value } = e.target;
    this.setState({ [name]: value, dataUnsaved: true });
  };

  onError = (value, key) => {
    this.setState(prevState => {
      const error = isValidArray(prevState[key])
        ? { error: !prevState[key].length, message: ERROR_MSG.DEFAULT_MSG }
        : value;
      return {
        errors: {
          ...prevState.errors,
          [key]: error
        }
      };
    });
  };

  /**
   *  For upload files
   * @param files
   * @returns {Promise<void>}
   */
  onFilesChange = async file => {
    this.setState({
      isLoading: true,
      selectedImage: this.state.selectedImage ? "" : null
    });
    const { uploadFileDispatch } = this.props;
    const { files, dataUnsaved } = this.state;
    try {
      if (!this.inValidFile) {
        const attachmentPayload = FormDataForImage(file, "file");
        //console.log("attachmentpayload", attachmentPayload);
        attachmentPayload.append("isMis", false);
        const response = await uploadFileDispatch(undefined, attachmentPayload);
        if (response) {
          const { status, message, data } = response;
          this.setState({
            count: data.id,
            selectedImage: data.name,
            extension: file[0].extension,
            isLoading: false
          });
          //this.setState({ selectedImage: data.name });
          //this.setState({ extension: file[0].extension });
          //this.setState({ isLoading: false });

          if (this.props.isEdit) {
            toast.success(
              <p className="toast-text-alignment">
                {this.props.groupData && this.props.groupData.isEdit
                  ? "File Updated Successfully"
                  : "File Updated Successfully"}
              </p>,
              successToastStyle
            );
          }
          if (status) {
            //console.log("data", data, "status", status);
            //console.log("fileData ", file);
            this.setState({
              // files: [...files, { ...data, extension: file[0].extension }],
              [files]: { ...data, extension: file[0].extension },
              dataUnsaved: true
            });
          } else {
            toast.error(
              <p className="toast-text-alignment">{message}</p>,
              errorToastStyle
            );
          }
        } else {
          toast.error(
            <p className="toast-text-alignment">
              {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
            </p>,
            errorToastStyle
          );
        }
      }
      this.inValidFile = false;
    } catch (e) {
      this.setState({ isLoading: false });
      toast.error(
        <p className="toast-text-alignment">{e.message}</p>,
        errorToastStyle
      );
    }
  };

  onFilesError = file => {
    if (file && file.message) {
      if (file.message.includes("too large")) {
        toast.error(
          <p className="toast-text-alignment">
            The File Exceeds The Maximum Size Limit Of 10MB
          </p>,
          errorToastStyle
        );
      } else if (file.message.includes("valid file type")) {
        toast.error(
          <p className="toast-text-alignment">Invalid File Type</p>,
          errorToastStyle
        );
      } else {
        toast.error(
          <p className="toast-text-alignment">{file.message}</p>,
          errorToastStyle
        );
      }
    }
    this.inValidFile = true;
  };

  removeFile = async (file, index) => {
    const { removeFileDispatch } = this.props;
    const { files } = this.state;
    try {
      const response = await removeFileDispatch(undefined, {
        fid: file.id
      });
      if (response) {
        const { status, message } = response;
        if (status) {
          files.splice(index, 1);
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          );
          this.setState({ files });
        } else {
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
        }
      } else {
        toast.error(
          <p className="toast-text-alignment">
            {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
          </p>,
          errorToastStyle
        );
      }
    } catch (e) {
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
    }
  };

  getImageType() {
    //const { selectedImage } = this.state;
    const uploadedImage = this.props.isEdit
      ? this.props.groupData.image[0].mineType
      : this.state.selectedImage;
    // Get the file extension
    if (uploadedImage) {
      const fileType = uploadedImage
        .split(".")
        .pop()
        .toLowerCase();

      switch (fileType) {
        case "jpeg":
          this.setState({ extension: "JPEG" });
          break;
        case "png":
          this.setState({ extension: "PNG" });
          break;
        case "jpg":
          this.setState({ extension: "JPG" });
          break;
        default:
          this.setState({ extension: "Unknown Image Type" });
      }
    }
  }

  handleFileChange = files => {
    const imageFile = files.find(file => file.type.startsWith("image/"));
    if (imageFile) {
      this.setState({ selectedImage: imageFile });
      const imageURL = URL.createObjectURL(imageFile);
      this.setState({ imageURL });
    }
  };

  handleRemoveImage = () => {
    if (this.state.selectedImage) {
      this.setState({
        selectedImage: null,
        extension: null,
        count: [],
        dataUnsaved: true
      });
      //this.setState({ extension: null });
      //this.setState({ count: [] });
      toast.success(
        <p className="toast-text-alignment">File Removed Successfully</p>,
        successToastStyle
      );
    }
  };

  onSubmit = async e => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isApiLoading: STATUS.LOADING, searchRoles: "" });
    const {
      createPmg,
      getUsersListDispatch,
      togglePopUp,
      callApiOnSuccess
    } = this.props;
    const {
      title,
      pageURL,
      description,
      selectedDate,
      file,
      editDate,
      releaseDate,
      iigAccess,
      active,
      count
    } = this.state;
    const postData = {
      title,
      pageURL,
      description,
      selectedDate,
      file,
      releaseDate,
      iigAccess,
      active
    };
    this.openConfirmationAlert(e);
    togglePopUp(e);
    const data = pmgUpdateAddMemberFormAction(this.state);
    const response = await createPmg(postData);
    if (response) {
      const { status, message, data } = response;
      status
        ? toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          )
        : toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
      status && getUsersListDispatch(undefined);
      this.openConfirmationAlert(e);
      this.setState({ isApiLoading: STATUS.SUCCESS, dataUnsaved: false });
    } else {
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
    }
  };

  onChangeSearch = (e, value) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState(prevState => {
      const rolesListAfterSearch = searchByValueHelper(
        prevState.rolesList,
        e,
        value,
        ["roleName"]
      );
      return {
        rolesSearch: value,
        rolesList: [...rolesListAfterSearch]
      };
    });
  };

  onSelectRole = e => {
    e.preventDefault();
    const { value } = e.target;
    this.setState(prevState => {
      let currentRole = prevState.rolesList.find(obj => obj.roleId === +value);
      currentRole.checked = !currentRole.checked;
      return {
        rolesList: [...prevState.rolesList],
        error: {
          ...prevState.error,
          rolesList: {
            error: !prevState.rolesList.filter(role => role.checked).length,
            message:
              !prevState.rolesList.filter(role => role.checked).length &&
              ERROR_MSG.DEFAULT_MSG
          }
        }
      };
    });
  };

  validateForm = e => {
    e.preventDefault();
    e.stopPropagation();
    const {
      title,
      releaseDate,
      pageURL,
      description,
      submitBtnText,
      errors,
      selectedImage,
      selectedDate,
      file,
      count
    } = this.state;

    let isValid = true;

    this.validateField("title", title);
    this.validateField("description", description);
    this.validateField("pageURL", pageURL);
    this.validateField(
      "selectedDate",
      selectedDate !== null
        ? selectedDate
        : this.props.groupData && this.props.groupData.releaseDate
    );
    this.validateField("file", selectedImage);
    const isTitleValid = TITLE_VALIDATE(title).error === false;
    const isImageValid = IMAGE_VALIDATE(selectedImage).error === false;
    const isDateValid =
      DATE_VALIDATE(
        selectedDate !== null
          ? selectedDate
          : this.props.groupData && this.props.groupData.releaseDate
      ).error === false;
    const isDescriptionValid =
      DESCRIPTION_VALIDATE(description).error === false;
    const isFormValid =
      isTitleValid && isDateValid && isDescriptionValid && isImageValid;

    return isFormValid;
  };

  errors = {};
  validateField = (fieldName, value) => {
    switch (fieldName) {
      case "title":
        this.errors.title = TITLE_VALIDATE(value);
        break;
      case "description":
        this.errors.description = DESCRIPTION_VALIDATE(value);
        break;
      case "selectedDate":
        this.errors.selectedDate = DATE_VALIDATE(value);
        break;
      case "file":
        this.errors.file = IMAGE_VALIDATE(value);
        break;

      default:
        break;
    }

    this.setState({
      errors: { ...this.state.errors, ...this.errors }
    });
  };

  handleOtpModal = async e => {
    e.preventDefault();
    e.stopPropagation();
    let isValidData = await this.validateForm(e);
    if (isValidData) {
      this.openConfirmationAlert(e);
    } else {
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
        errorToastStyle
      );
    }
  };

  handleEditConfirmation = async e => {
    e.preventDefault();
    e.stopPropagation();
    //console.log(this.state.selectedDate, "selectedDate");
    //  const inputDate = new Date(this.state.selectedDate);

    // const formattedDate = inputDate.toLocaleDateString("en-GB", {
    //   day: "2-digit",
    //   month: "2-digit",
    //   year: "numeric"
    // });

    const inputDate = new Date(this.state.selectedDate);
    const date11 = new Date(inputDate);
    const day = date11.getDate();
    const month = date11.getMonth() + 1; // Months are 0-indexed, so add 1
    const year = date11.getFullYear();
    //const formattedDate = `${day}-${month}-${year}`;
    const paddedDay = day < 10 ? `0${day}` : day;
    const paddedMonth = month < 10 ? `0${month}` : month;
    const formattedDate = `${paddedDay}/${paddedMonth}/${year}`;
    //console.log("formattedDate from create form", formattedDate);
    //const formattedDate = `${day}-${month}-${year}`;

    const payloadForEdit = {
      title: this.state.title,
      description: this.state.description,
      pageUrl: this.state.pageURL,
      releaseDate: formattedDate,
      active: this.state.isActive,
      image: [this.state.count]
    };

    if (payloadForEdit.releaseDate == "01/01/1970") {
      const inputDate = new Date(this.props.groupData.releaseDate);
      const date11 = new Date(inputDate);
      const day = date11.getDate();
      const month = date11.getMonth() + 1; // Months are 0-indexed, so add 1
      const year = date11.getFullYear();
      //const formattedDate = `${day}-${month}-${year}`;
      const paddedDay = day < 10 ? `0${day}` : day;
      const paddedMonth = month < 10 ? `0${month}` : month;
      const formattedDate = `${paddedDay}/${paddedMonth}/${year}`;
      payloadForEdit.releaseDate = formattedDate;
    }

    const responseData = await pmgMemberUpdateFormAction(
      payloadForEdit,
      this.props.groupData.id
    );
    //console.log("from edit", payloadForEdit);
    return responseData;
  };

  handleAddMemberConfirmation = async e => {
    e.preventDefault();
    e.stopPropagation();

    // const selectedDate =
    //   selectedDate && this.state.selectedDate.toISOString().split("T")[0];
    // const parts = selectedDate && selectedDate.split("-");
    // const formattedDate = parts && `${parts[2]}-${parts[1]}-${parts[0]}`;

    // const inputDate = new Date(this.state.selectedDate);

    // const formattedDate = inputDate.toLocaleDateString("en-GB", {
    //   day: "2-digit",
    //   month: "2-digit",
    //   year: "numeric"
    // });

    const inputDate = new Date(this.state.selectedDate);
    const date11 = new Date(inputDate);
    const day = date11.getDate();
    const month = date11.getMonth() + 1; // Months are 0-indexed, so add 1
    const year = date11.getFullYear();
    //const formattedDate = `${day}-${month}-${year}`;
    const paddedDay = day < 10 ? `0${day}` : day;
    const paddedMonth = month < 10 ? `0${month}` : month;
    const formattedDate = `${paddedDay}/${paddedMonth}/${year}`;
    //console.log("formattedDate from create form", formattedDate);
    //const formattedDate = `${day}-${month}-${year}`;

    const payloadForCreate = {
      title: this.state.title,
      description: this.state.description,
      pageUrl: this.state.pageURL,
      releaseDate: formattedDate,
      active: this.state.isActive,
      image: [this.state.count]
    };

    const response = await pmgUpdateAddMemberFormAction(payloadForCreate);
    return response;
  };

  getSecurityKey = async (e, editBoolean) => {
    //console.log(this.validateForm, "validateForm");
    if (this.validateForm) {
      e.preventDefault();
      e.stopPropagation();
      let { userSecurityKeyV2 } = this.props;
      const { password } = this.state;
      const notificationInfoResponse = editBoolean
        ? await this.handleEditConfirmation(e)
        : await this.handleAddMemberConfirmation(e);
      if (notificationInfoResponse) {
        const { status, message, data } = notificationInfoResponse;
        this.setState({ showAlert: false });
        this.props.togglePopUp(e, true);
        if (data) {
          if (Object.keys(data) && Object.keys(data).length > 0) {
            toast.success(
              <p className="toast-text-alignment">{message}</p>,
              successToastStyle
            );
            this.props.callApiOnSuccess(data);
          } else {
            toast.error(
              <p className="toast-text-alignment">{message}</p>,
              errorToastStyle
            );
          }
        }
      }
      try {
        await userSecurityKeyV2(e);
        e.preventDefault();
        e.stopPropagation();
        const { securityKeyData } = this.props;
        if (get(securityKeyData, "id")) {
          let userID = get(securityKeyData, "id");
          const encrypt = new JSEncrypt();
          encrypt.setPublicKey(get(securityKeyData, "key"));
          const encryptedPassword = encrypt.encrypt(password);
          this.setState({ encryptedPassword, userID });
          this.onSubmit(e);
        } else {
          toast.error(
            <p className="toast-text-alignment">
              Please check your credentials
            </p>,
            errorToastStyle
          );
        }
      } catch (e) {
        console.log(`Error ${e.message}`);
      }
    }
  };

  openConfirmationAlert = e => {
    this.setState(prevState => ({
      showAlert: !prevState.showAlert,
      allowPrompt: !prevState.allowPrompt
    }));
  };

  render() {
    const {
      isEditGroup,
      groupData,
      active,
      permission,
      isMakeUserApiLoading,
      onMakeUserActive,
      isApiLoading,
      isEdit,
      isImageUpLoading
    } = this.props;

    const {
      title,
      date,
      pageURL,
      description,
      releaseDate,
      submitBtnText,
      errors,
      showAlert,
      file,
      selectedDate,
      selectedImage,
      isLoading,
      isActive
    } = this.state;

    // const newDate =
    //   selectedDate && this.state.selectedDate.toISOString().split("T")[0];
    // const parts = newDate && newDate.split("-");
    // const formattedDate = parts && `${parts[2]}-${parts[1]}-${parts[0]}`;

    const date11 = new Date(selectedDate);
    const day = date11.getDate();
    const month = date11.getMonth() + 1; // Months are 0-indexed, so add 1
    const year = date11.getFullYear();
    // const formattedDate = `${day}-${month}-${year}`;
    const formattedDate = `${day}/${month}/${year}`;

    // const inputDate = new Date(this.state.selectedDate);

    // const formattedDate = inputDate.toLocaleDateString("en-GB", {
    //   day: "2-digit",
    //   month: "2-digit",
    //   year: "numeric"
    // });

    //console.log(this.state.selectedDate, formattedDate, "extension");
    //console.log(errors, "validations");
    //let toggleClass = this.state.isActive ? "toggle-active" : " toggle-inactive"
    const dateFormate = inputDate => {
      //console.log("from dateFormate", inputDate);
      const timestamp = inputDate;
      const date = new Date(timestamp * 1000);

      const day = date.getDate();

      const month = date.getMonth() + 1; // Months are 0-indexed in JavaScript

      const year = date.getFullYear();
      //console.log("year", year);

      const paddedDay = day < 10 ? `0${day}` : day;
      const paddedMonth = month < 10 ? `0${month}` : month;

      return `${paddedDay}/${paddedMonth}/${year}`;
    };

    return (
      <div className="register-inner create-user-register-inner">
        <Form
          onSubmit={e => {
            e.preventDefault();
            e.stopPropagation();
            this.handleOtpModal(e);
          }}
          noValidate
          className="signup-form"
        >
          <ConfirmationComponent
            show={showAlert}
            isLoading={isApiLoading}
            modalClass={"confirmation-modal"}
            saveHandler={e => {
              e.preventDefault();
              e.stopPropagation();
              this.getSecurityKey(e, isEdit);
            }}
            closeHandler={e => {
              this.openConfirmationAlert(e);
            }}
            content={"Are you sure you want to do this?"}
          />

          <Form.Group controlId="title">
            <div className="d-flex justify-content-between">
              <Form.Label className="label-style">
                Title
                <span className="required">*</span>
              </Form.Label>

              {/* {toggleClass = this.state.isActive ? "toggle-active" : " toggle-inactive"}
              {console.log("this.state.isActive", toggleClass)} */}
              {isEdit && (
                <div className="d-flex mt-2 mr-n2">
                  <p
                    className={`mb-0 mr-n3 pr-1 ${
                      this.state.isActive ? "toggle-active" : "toggle-inactive"
                    }`}
                  >
                    {this.state.isActive ? "Active" : "Inactive"}
                  </p>

                  <Form.Group
                    controlId="designation"
                    className="mb-0 ml-3 mr-2"
                  >
                    <Form.Check
                      type="checkbox"
                      label={
                        <span>
                          {isMakeUserApiLoading ? (
                            <Spinner animation="border" size="sm" />
                          ) : null}
                        </span>
                      }
                      checked={this.state.isActive}
                      onChange={() => {
                        this.setState(prevState => ({
                          isActive: !prevState.isActive,
                          dataUnsaved: true
                        }));
                      }}
                      className={`form-toggle ${
                        this.state.isActive ? "checked" : "unchecked"
                      } active-user`}
                      //className="form-toggle unchecked active-user"
                    />
                  </Form.Group>
                </div>
              )}
              {/*{isEdit && (*/}
              {/*  <div className="d-flex mt-2 mr-n2">*/}
              {/*    <p*/}
              {/*      className={`mb-0 mr-n3 pr-1 ${*/}
              {/*        this.state.newActive ? "toggle-active" : ""*/}
              {/*      }`}*/}
              {/*    >*/}
              {/*      {this.state.newActive ? "Active" : "Inactive"}*/}
              {/*    </p>*/}

              {/*    <Form.Group controlId="designation" className="mb-0 mr-1">*/}
              {/*      <Form.Check*/}
              {/*        type="checkbox"*/}
              {/*        label={*/}
              {/*          <span>*/}
              {/*            {isMakeUserApiLoading ? (*/}
              {/*              <Spinner animation="border" size="sm" />*/}
              {/*            ) : null}*/}
              {/*          </span>*/}
              {/*        }*/}
              {/*        checked={this.state.newActive}*/}
              {/*        onChange={() =>*/}
              {/*          this.setState(prevState => ({*/}
              {/*            //isActive: !prevState.isActive,*/}
              {/*            newActive: false*/}
              {/*          }))*/}
              {/*        }*/}
              {/*        className={`form-toggle ${*/}
              {/*          this.state.newActive ? "checked" : "unChecked"*/}
              {/*        } active-user`}*/}
              {/*      />*/}
              {/*    </Form.Group>*/}
              {/*  </div>*/}
              {/*)}*/}
            </div>
            <Form.Control
              name="title"
              as="textarea"
              value={title}
              onChange={e => {
                e.preventDefault();
                e.stopPropagation();
                this.handleChange(e);
                this.validateField("title", e.target.value);
              }}
              isInvalid={errors.title && errors.title.error}
              onBlur={() => this.validateField("title", title)}
              placeholder="Enter Title"
              maxLength="150"
              //  className="field-width"
              className={`${isEdit ? "field-width-cms" : "addFormText "}`}
              style={{ height: "88px" }}
            />
            <p className="subtext pt-1 mb-0">
              Remaining characters : {150 - this.state.title.length}
            </p>

            <Form.Control.Feedback type="invalid">
              {get(errors, "title.message", null)}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="pageURL">
            <Form.Label className="label-style"> Page URL </Form.Label>
            <Form.Control
              name="pageURL"
              type="text"
              value={pageURL}
              onChange={e => {
                e.preventDefault();
                e.stopPropagation();
                this.handleChange(e);
                this.validateField("pageURL", e.target.value);
              }}
              placeholder="Enter URL"
              // className="field-width"
              className={`${isEdit ? "field-width-cms" : "addFormText "}`}
            />
            <Form.Control.Feedback type="invalid">
              {get(errors, "pageURL.message", null)}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="description">
            <Form.Label className="label-style">Description</Form.Label>
            <span className="required">*</span>
            <Form.Control
              name="description"
              as="textarea"
              value={description}
              onChange={e => {
                e.preventDefault();
                e.stopPropagation();
                this.handleChange(e);
                this.validateField("description", e.target.value);
              }}
              isInvalid={errors.description && errors.description.error}
              onBlur={() => this.validateField("description", description)}
              maxLength="400"
              placeholder="Enter Description"
              //  className="field-width"
              className={`${isEdit ? "field-width-cms" : "addFormText "}`}
              style={{ height: "150px" }}
            />
            <p className="subtext pt-1 mb-0">
              Remaining characters : {400 - this.state.description.length}
            </p>

            <Form.Control.Feedback type="invalid">
              {get(errors, "description.message", null)}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="selectedDate">
            <Form.Label className="label-style">Release Date</Form.Label>
            <span className="required">*</span>

            {isEdit ? (
              <DatePicker
                name="selectedDate"
                startDate={new Date()}
                onChange={date =>
                  this.handleEditDateChange(
                    date,
                    this.props.groupData.releaseDate
                  )
                }
                placeholderText="DD/MM/YYYY"
                selected={this.props.groupData.releaseDate}
                value={selectedDate}
                className={`releaseDate ${
                  isEdit ? "field-width-cms" : " addFormText"
                } `}
              />
            ) : (
              <DatePicker
                name="selectedDate"
                startDate={new Date()}
                onChange={this.handleDateChange}
                placeholderText="DD/MM/YYYY"
                selected={selectedDate}
                value={selectedDate}
                isInvalid={errors.selectedDate && selectedDate == null}
                className={`releaseDate ${
                  isEdit ? "field-width-cms" : " addFormText"
                } `}
              />
            )}
          </Form.Group>
          {/*<DatePicker*/}
          {/*  name="selectedDate"*/}
          {/*  value={*/}
          {/*    selectedDate*/}
          {/*      ? formattedDate*/}
          {/*      : groupData && dateFormate(groupData.releaseDate)*/}
          {/*  }*/}
          {/*  selected={groupData?this.props.groupData.releaseDate:null}*/}
          {/*  onChange={this.handleDateChange}*/}
          {/*  dateFormat="dd/mm/yyyy"*/}
          {/*  placeholderText="DD/MM/YYYY"*/}
          {/*  onBlur={() => this.validateField("selectedDate", selectedDate)}*/}
          {/*  isInvalid={errors.selectedDate && errors.selectedDate.error}*/}
          {/*  // className={*/}
          {/*  //   errors.selectedDate && errors.selectedDate.error*/}
          {/*  //     ? "date-input-div is-invalid"*/}
          {/*  //     : ""*/}
          {/*  // }*/}
          {/*  className={`releaseDate ${*/}
          {/*    isEdit ? "field-width-cms" : " addFormText"*/}
          {/*  } `}*/}
          {/*/>*/}
          <div
            style={{
              color: "#fc192e",
              fontFamily: "mpsb",
              fontSize: 11,
              fontStyle: "italic",
              marginTop: "0.25rem",
              display: selectedDate ? "none" : null
            }}
          >
            {get(errors, "selectedDate.message", null)}
          </div>
          <Form.Group controlId="file">
            <Form.Label className="label-style">
              Upload Meeting Image
            </Form.Label>
            <span className="required">*</span>
            {this.state.selectedImage ? (
              <div className="d-flex showImage">
                <div
                  className="d-flex flex-column justify-content-center align-items-center imgIcon"
                  style={{ backgroundImage: `url(${ImageBackground})` }}
                >
                  <p className="text-white text-uppercase mt-4 iconText">
                    {this.state.extension !== null ? this.state.extension : ""}
                  </p>
                </div>
                <div className="image uploadedPhoto">
                  {this.state.selectedImage.length > 20
                    ? this.state.selectedImage.split(".", 1)[0].substr(0, 20) +
                      "..."
                    : this.state.selectedImage.split(".", 1)[0]}
                </div>
                <div className="d-flex align-items-start updateImage">
                  <Files
                    onChange={this.onFilesChange}
                    onBlur={() => this.validateField("file", selectedImage)}
                    onError={this.onFilesError}
                    multiple={false}
                    accepts={IMAGE_FORMAT}
                    maxFileSize={FILE_SIZE_LIMIT.OTHER_FORMATS}
                    className="pmg-update-edit-files"
                    data-test="add-files"
                    isInvalid={errors.file && errors.file.error}
                    clickable
                  >
                    <img
                      src={CancleIcon}
                      alt="Cancel_Icon"
                      className="pmg-edit-icon"
                    />
                  </Files>
                </div>
              </div>
            ) : isLoading ? (
              <>
                <LoaderPage loading={isImageUpLoading === STATUS.LOADING} />
                <Files
                  onChange={this.onFilesChange}
                  onBlur={() => this.validateField("file", selectedImage)}
                  onError={this.onFilesError}
                  multiple={false}
                  accepts={IMAGE_FORMAT}
                  maxFileSize={FILE_SIZE_LIMIT.OTHER_FORMATS}
                  className="best-practices-add-files cms-add-files"
                  data-test="add-files"
                  isInvalid={errors.file && errors.file.error}
                  clickable
                >
                  <div>
                    <Image
                      src={IconPlus}
                      className="addFile_plus"
                      alt="Plus Icon"
                    />
                    <div
                      className="add-file-text pt-2"
                      data-test="label-add-document"
                    >
                      Add
                    </div>
                  </div>
                </Files>
                <p className="add-file-subtext font-semibold pt-1 mb-0 font-italic">
                  Supported image types: .png, .jpg, .jpeg <br />
                  Max image size: 10MB
                </p>
              </>
            ) : (
              <div>
                {" "}
                <Files
                  onChange={this.onFilesChange}
                  onBlur={() => this.validateField("file", selectedImage)}
                  onError={this.onFilesError}
                  multiple={false}
                  accepts={IMAGE_FORMAT}
                  maxFileSize={FILE_SIZE_LIMIT.OTHER_FORMATS}
                  className="best-practices-add-files cms-add-files"
                  data-test="add-files"
                  isInvalid={errors.file && errors.file.error}
                  clickable
                >
                  <div>
                    <Image
                      src={IconPlus}
                      className="addFile_plus"
                      alt="Plus Icon"
                    />
                    <div
                      className="add-file-text pt-2"
                      data-test="label-add-document"
                    >
                      Add
                    </div>
                  </div>
                </Files>
                <p className="add-file-subtext font-semibold pt-1 mb-0 font-italic">
                  Supported image types: .png, .jpg, .jpeg <br />
                  Max image size: 10MB
                </p>
                <div
                  style={{
                    color: "#fc192e",
                    fontFamily: "mpsb",
                    fontSize: 11,
                    fontStyle: "italic",
                    marginTop: "0.25rem"
                  }}
                >
                  {get(errors, "file.message", null)}
                </div>
                {/* <Form.Control.Feedback type="invalid">
                  {get(errors, "file.message", null)}
                </Form.Control.Feedback> */}
              </div>
            )}
          </Form.Group>
          {/* <Button
            variant="primary"
            type="submit"
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              this.handleOtpModal(e);
            }}
            className="btn-orange full-width edit-create-user-btn best-practice-submit-btn"
          >
            {isEdit ? "UPDATE" : "ADD"}
          </Button>*/}

          <div className="pt-1">
            <Button
              variant="primary"
              type="submit"
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.handleOtpModal(e);
              }}
              className="btn-orange full-width mb-3 edit-create-user-btn"
            >
              {isEdit ? "UPDATE" : "ADD"}
            </Button>
          </div>
          {/*</Form.Group>*/}
        </Form>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    // data: state.pmgAddMemberFormEdit,
    // data: state.pmgAddMemberForm,
    isImageUpLoading: state.commonReducer.isImageUpLoading
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      // createBestPracticesAction: createBestPracticesAction,
      uploadFileDispatch: uploadFileAction,
      removeFileDispatch: removeFileAction
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateForm);
